import {
  PendingActions,
  Apartment,
  InsertChartOutlinedTwoTone,
  Discount,
  Notifications,
  Settings,
  ViewColumn,
  Build,
  BugReport,
  Link as LinkIcon,
  PhoneIphone,
  Event
} from "@mui/icons-material"

export const items = [
  {
    section: "Management",
    children: [
      {
        title: "Organizations",
        path: "/admin/organizations",
        icon: <Apartment sx={{ width: "21px", height: "21px" }} />
      },
      {
        title: "Pending Requests",
        path: "/admin/pending-requests",
        icon: <PendingActions sx={{ width: "21px", height: "21px" }} />
      }
    ]
  },
  {
    section: "Analytics",
    children: [
      {
        title: "Insights",
        path: "/admin/insights",
        icon: <InsertChartOutlinedTwoTone sx={{ width: "21px", height: "21px" }} />
      }
    ]
  },
  {
    section: "Fleet",
    children: [
      {
        title: "Service Types",
        path: "/admin/service-types",
        icon: <Build sx={{ width: "21px", height: "21px" }} />
      }
    ]
  },
  {
    section: "Scheduling",
    children: [
      {
        title: "Holidays",
        path: "/admin/holidays",
        icon: <Event sx={{ width: "21px", height: "21px" }} />
      }
    ]
  },
  {
    section: "Billing",
    children: [
      {
        title: "Coupons",
        path: "/admin/coupons",
        icon: <Discount sx={{ width: "21px", height: "21px" }} />
      }
    ]
  },
  {
    section: "Configuration",
    children: [
      {
        title: "Provider Fields",
        path: "/admin/provider-name-fields",
        icon: <Settings sx={{ width: "21px", height: "21px" }} />
      },
      {
        title: "Structure Fields",
        path: "/admin/provider-structure-fields",
        icon: <ViewColumn sx={{ width: "21px", height: "21px" }} />
      }
    ]
  },
  {
    section: "Support",
    children: [
      {
        title: "Issue Reports",
        path: "/admin/issue-reports",
        icon: <BugReport sx={{ width: "21px", height: "21px" }} />
      }
    ]
  },
  {
    section: "Communications",
    children: [
      {
        title: "Push Notifications",
        path: "/admin/push-notifications",
        icon: <Notifications sx={{ width: "21px", height: "21px" }} />
      },
      {
        title: "Devices",
        path: "/admin/devices",
        icon: <PhoneIphone sx={{ width: "21px", height: "21px" }} />
      },
      {
        title: "Short Links",
        path: "/admin/short-links",
        icon: <LinkIcon sx={{ width: "21px", height: "21px" }} />
      }
    ]
  }
]
